module.exports = __webpack_public_path__ + "img/sv34.3ad6f43d.svg";